export const getStyles = (theme: any) => ({
  styles: {
    wrapper: {
      backgroundColor: theme.palette.grey[400],
      padding: '16px',
      marginBottom: 5,
      borderRadius: "12px",
    },
    name: {
      display: "flex",
      justifyContent: "space-between",
      wordWrap: "break-word",
      fontSize: "10px",
      color: theme.palette.grey[900],
    },
    text: {
      color: theme.palette.grey[900],
      fontSize: "12px",
    },
  },
});
